import { Modal } from '@atoms/Modal';
import { Badge } from '@atoms/Badge';
import { useOrderDetailStore } from '@store/uiStore';
import { formatCurrency, formatDate, ORDER_STATUS_LABELS } from '@utils/formatters';

export function OrderDetailModal() {
  const { order, closeOrderDetail } = useOrderDetailStore();

  return (
    <Modal
      open={Boolean(order)}
      onClose={closeOrderDetail}
      title={order ? `Sipariş #${order.id.slice(0, 8)}` : 'Sipariş Detayı'}
    >
      {order && (
        <div className="space-y-4">
          <div className="flex flex-wrap items-start justify-between gap-2">
            <div>
              <p className="font-semibold">
                {order.restaurant?.name ?? order.wholesaler?.name ?? '—'}
              </p>
              <p className="text-sm text-gray-500">{formatDate(order.createdAt)}</p>
              <p className="text-sm text-gray-500">
                {order.orderType === 'delivery' ? 'Teslimat' : 'Gel-Al'}
              </p>
            </div>
            <Badge>{ORDER_STATUS_LABELS[order.status]}</Badge>
          </div>

          {order.note && (
            <p className="rounded-lg bg-gray-50 p-3 text-sm text-gray-700">
              Not: {order.note}
            </p>
          )}

          <ul className="divide-y rounded-lg border">
            {order.items?.map((item) => (
              <li key={item.id ?? item.productId} className="flex justify-between px-3 py-2 text-sm">
                <span>
                  {item.productName} × {item.quantity} {item.unit}
                </span>
                <span>{formatCurrency(item.lineTotal)}</span>
              </li>
            ))}
          </ul>

          <div className="space-y-1 text-sm">
            <div className="flex justify-between">
              <span>Ara Toplam</span>
              <span>{formatCurrency(order.subtotal)}</span>
            </div>
            {order.deliveryFee > 0 && (
              <div className="flex justify-between">
                <span>Teslimat</span>
                <span>{formatCurrency(order.deliveryFee)}</span>
              </div>
            )}
            {order.discountTotal > 0 && (
              <div className="flex justify-between text-green-600">
                <span>İndirim</span>
                <span>-{formatCurrency(order.discountTotal)}</span>
              </div>
            )}
            <div className="flex justify-between border-t pt-2 text-base font-bold">
              <span>Toplam</span>
              <span className="text-brand-600">{formatCurrency(order.totalPrice)}</span>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
}
